import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';
import { getRefreshToken, hasSession, loginWithTelegram, setTokens } from './api';
import { initTelegram, isInsideTelegram } from './telegram';

interface SessionState {
  /** Готова ли авторизация: пока false, приватные запросы делать рано. */
  ready: boolean;
  authorized: boolean;
  insideTelegram: boolean;
}

const SessionContext = createContext<SessionState>({
  ready: false,
  authorized: false,
  insideTelegram: false,
});

/**
 * Каталог открыт всем, а корзина и избранное требуют входа. Вход происходит
 * молча: initData из Telegram обменивается на пару токенов при старте.
 * Вне Telegram приложение остаётся в режиме просмотра.
 */
export function SessionProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<SessionState>({
    ready: false,
    authorized: false,
    insideTelegram: false,
  });

  useEffect(() => {
    initTelegram();
    const inside = isInsideTelegram();

    void (async () => {
      if (!inside && !getRefreshToken()) {
        setState({ ready: true, authorized: false, insideTelegram: false });
        return;
      }

      try {
        const ok = await loginWithTelegram();
        setState({ ready: true, authorized: ok || hasSession(), insideTelegram: inside });
      } catch {
        setTokens(null, null);
        setState({ ready: true, authorized: false, insideTelegram: inside });
      }
    })();
  }, []);

  const value = useMemo(() => state, [state]);

  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession(): SessionState {
  return useContext(SessionContext);
}
